// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.op-circle-icon{color:var(--colorSuccess)}`, "",{"version":3,"sources":["webpack://./app/new-components/OpIcon/icons/OpCircleIcon/OpCircleIcon.scss"],"names":[],"mappings":"AAAA,gBACE,yBAAA","sourcesContent":[".op-circle-icon {\n  color: var(--colorSuccess);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
